// ======================================================================
// FILE: src/modules/wms/dashboard/components/WorkTrendCard.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   Work Trend Chart
// ======================================================================

import React from "react";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";


export default function WorkTrendCard({
  data = [],
}) {

  const rows = Array.isArray(data)
    ? data
    : [];

  const chartData = rows.map((item) => ({
    date: item.date,
    open: Number(item.open || 0),
    in_progress: Number(item.in_progress || 0),
    completed: Number(item.completed || 0),
    overdue: Number(item.overdue || 0),
  }));

  return (

    <div className="card shadow-sm mb-4">

      <div className="card-header bg-white">

        <h5 className="mb-0">
          Work Trend (Last 30 Days)
        </h5>

      </div>


      <div className="card-body">

        <ResponsiveContainer
          width="100%"
          height={320}
        >

          <LineChart
            data={chartData}
          >

            <CartesianGrid
              strokeDasharray="3 3"
            />

            <XAxis
              dataKey="date"
              tickFormatter={(value) => {
                if (!value) {
                  return "";
                }

                const parts = value.split("-");

                if (parts.length !== 3) {
                  return value;
                }

                return `${parts[2]}/${parts[1]}`;
              }}
            />

            <YAxis />

            <Tooltip />

            <Legend />


            <Line
              type="monotone"
              dataKey="open"
              name="Open"
              stroke="#0d6efd"
              strokeWidth={3}
            />


            <Line
              type="monotone"
              dataKey="in_progress"
              name="In Progress"
              stroke="#fd7e14"
              strokeWidth={3}
            />


            <Line
              type="monotone"
              dataKey="completed"
              name="Completed"
              stroke="#198754"
              strokeWidth={3}
            />


            <Line
              type="monotone"
              dataKey="overdue"
              name="Overdue"
              stroke="#dc3545"
              strokeWidth={3}
            />

          </LineChart>

        </ResponsiveContainer>

      </div>

    </div>

  );
}